/**
 * Single source for the browser API base URL. CRA inlines REACT_APP_* at build time.
 * Trailing slashes are removed so callers can safely use `${getApiBaseUrl()}/path`.
 */
export function getApiBaseUrl() {
  const raw = process.env.REACT_APP_API_URI;
  if (raw == null) return "";
  const s = String(raw).trim();
  if (!s) return "";
  return s.replace(/\/+$/, "");
}
